import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { ContentBodyContext } from '../MainContent';
import { MessageContext } from './Message';
import axios from 'axios'
import swal from 'sweetalert';
import jwt from 'jwt-decode'
import qs from 'querystring'

function ModalFeedback() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateMessage, dispatchMessage } = useContext(MessageContext);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (dataForm.feedback !== '' && !dataForm.isSubmitting) {
            if ((stateMessage.selected != null ? stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).status.id : stateMessage.modalFeedback.data.status.id) == 3) {
                submit('feedback')
            } else {
                submit('close')
            }
        } else {
            setdataForm({
                ...dataForm,
                errFeedback: 'Please enter your feedback.'
            })
        }
    }

    const submit = (action) => {
        setdataForm({
            ...dataForm,
            isSubmitting: true
        })

        stateContentBody.socket.emit(`helpdesk-user-feedback-close`, {
            token: localStorage.getItem('token-helpdesk-umy'),
            data: {
                chat_id: stateMessage.selected != null ? stateMessage.selected : stateMessage.modalFeedback.data.id,
                sender: 'user',
                action: action,
                ratting: dataForm.ratting,
                feedback: dataForm.feedback,
                workunit: stateMessage.selected != null ? stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).workunit : stateMessage.modalFeedback.data.workunit
            }
        })
    }

    useEffect(() => {
        if (stateMessage.trigger.message == "helpdesk-user-feedback-close") {
            if (stateMessage.trigger.data == 'success' && stateMessage.trigger.action.data.sender == 'user') {
                //update list message
                const tempList = {
                    action: "feedback",
                    id: stateMessage.trigger.action.data.chat_id,
                    status: {
                        id: 3,
                        name: "selesai"
                    },
                    ratting: stateMessage.trigger.action.data.ratting,
                    feedback: stateMessage.trigger.action.data.feedback
                }
                dispatchMessage({
                    type: 'TEMP_LIST',
                    tempListMessage: tempList,
                })

                handleCancel()
                dispatchMessage({
                    type: 'SHOW_CHAT',
                    showChat: false,
                    selected: null
                })
                swal("Success!", `Thanks for your feedback${stateMessage.modal == true ? ',please select the category again!' : '!'}`, "success", {
                    button: "OK",
                });
            } else {
                setdataForm({
                    ...dataForm,
                    isSubmitting: false
                })
            }
        }
    }, [stateMessage.trigger])


    const handleMoreClick = () => {
        dispatchMessage({
            type: 'NEW_CHAT',
            modal: false
        })

        dispatchMessage({
            type: 'SHOW_CHAT',
            showChat: true,
            selected: stateMessage.modalFeedback.data.id
        })

        handleCancel()
    }
    const handleMessageInput = (event) => {
        setdataForm({
            ...dataForm,
            feedback: event.target.value,
            errFeedback: event.target.value == '' ? 'Please enter your feedback.' : null
        })
    }

    const handleCancel = () => {
        setdataForm(initialState)

        dispatchMessage({
            type: 'MODAL_FEEDBACK',
            modalFeedback: { status: false, data: null }
        })
    }


    const initialState = {
        feedback: '',
        errFeedback: null,
        ratting: 0,
        errRatting: null,
        isSubmitting: false,
    }
    const [dataForm, setdataForm] = useState(initialState)


    const [renderModal, setRenderModal] = useState(<Fragment />)
    useEffect(() => {
        if (stateMessage.modalFeedback.status) {
            setRenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={true} backdrop={'static'} keyboard={true}>
                        <ModalHeader toggle={handleCancel} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            FeedBack
                        </ModalHeader>
                        <ModalBody>
                            {stateMessage.selected == null ? (
                                <Fragment>
                                    <div className="form-group">
                                        <div className="col-mx-auto m-0 p-0">
                                            <p style={{ fontSize: '1.3em', fontWeight: 'bold', marginBottom: '0' }}>{stateMessage.modalFeedback.data.workunit.name} <small className="ticket-info" style={{ fontSize: '0.6em', marginBottom: '0', float: 'right' }}>{new Date(stateMessage.modalFeedback.data.time).toISOString().replace(/T/, ' ').replace(/\..+/, '')}</small></p>
                                            <p className="ticket-info" style={{ fontSize: '1em', marginBottom: '0' }}>Topic : {stateMessage.modalFeedback.data.category.name}</p>
                                            <p>"{stateMessage.modalFeedback.data.message} <span style={{ color: 'blue', cursor: 'pointer' }} onClick={handleMoreClick}> ...read more</span>"</p>
                                        </div>
                                    </div>
                                    <br />
                                </Fragment>
                            ) : ''}
                            <div className="form-group">
                                <Typography component="legend">Rating</Typography>
                                <Rating
                                    style={{ fontSize: '3em' }}
                                    name="simple-controlled"
                                    value={dataForm.ratting}
                                    onChange={(event, newValue) => {
                                        setdataForm({ ...dataForm, ratting: newValue });
                                    }}
                                />
                            </div>
                            <div className="form-group row">
                                <Typography component="legend">Feedback</Typography>
                                <div className="input-group  has-validation">
                                    <textarea className={`form-control ${dataForm.errFeedback != null ? 'is-invalid' : ''}`} value={dataForm.feedback} id="feedback" name="feedback" onChange={handleMessageInput} style={{ height: '150px' }} placeholder="Type your feedback here" aria-describedby="validationInput" />
                                </div>
                                {(dataForm.errFeedback != null ? <small style={{ color: 'red' }}>{dataForm.errFeedback}</small> : '')}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button disabled={dataForm.isSubmitting} color="success" onClick={handleSubmit} style={{ textTransform: 'capitalize' }}>{dataForm.isSubmitting ? '...Sending Message' : 'Send'}<i className={dataForm.isSubmitting ? 'fas fa-spinner fa-pulse' : "fas fa-paper-plane"}></i></Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else {
            setRenderModal(<Fragment />)
        }
    }, [stateMessage.modalFeedback, dataForm])

    return (renderModal)
}

export default ModalFeedback
